export default function registerInview($, apower) {
  //or inview class when items become visible
  //product page screens animation management
  apower.offset = $.registerOnce({
    offsets: [],

    init: function () {
      $(window).$on("resize", this.update, this);
      apower.scroller.on("scroll", $.blockFn(this.onScroll, 500), this);

      //to make sure `fit` has been handled
      $.defer(this.update, this);
    },

    lastNavEl: null,

    onScroll: function (scrollTop) {
      var winHeight = $(window).height();
      var currNavEl = null;
      var currNavRate = 0;

      for (var i = 0; i < this.offsets.length; i++) {
        var item = this.offsets[i],
          el = item.el,
          top = item.top,
          bot = item.bot,
          height = item.height,
          rate = item.rate,
          isNavigationEl = item.isNavigationEl,
          isOnlyNavigationEl = item.isOnlyNavigationEl;

        if (height) {
          var visibleHeight =
            Math.min(bot, scrollTop + winHeight) - Math.max(top, scrollTop);
          var visibleRate = 0;

          if (visibleHeight > 0) {
            visibleRate = visibleHeight / Math.min(height, winHeight);
          }

          if (isNavigationEl && currNavRate < visibleRate) {
            currNavRate = visibleRate;
            currNavEl = el[0];
          }

          if (visibleRate > rate) {
            if (!item.inview) {
              item.inview = true;

              if (!isOnlyNavigationEl) {
                el.addClass("inview");
              }

              el.$trigger("inview");
            }
          } else {
            if (item.inview) {
              item.inview = false;

              if (!isOnlyNavigationEl) {
                el.removeClass("inview");
              }

              el.$trigger("outview");
            }
          }
        }
      }

      if (currNavEl !== this.lastNavEl) {
        this.trigger("updatenav", currNavEl, this.lastNavEl);

        this.lastNavEl = currNavEl;
      }
    },

    add: function (item) {
      $.extend(item, {
        top: 0,
        bot: 0,
        height: 0,
      });

      this.offsets.push(item);
    },

    remove: function (el) {
      for (var i = 0; i < this.offsets.length; i++) {
        if (el === this.offsets[i].el) {
          this.offsets.splice(i, 1);
          return true;
        }
      }

      return false;
    },

    update: function () {
      var scrollTop = $("html").scrollTop() || $("body").scrollTop();

      for (var i = 0; i < this.offsets.length; i++) {
        var item = this.offsets[i],
          el = item.el,
          top = el[0].getBoundingClientRect().top + scrollTop,
          height = el[0].offsetHeight;

        item.top = top;
        item.bot = height + top;
        item.height = height;
        item.inview = false;
      }

      this.onScroll(apower.scroller.lastScrollTop);
    },
  });
  $.registerDir("inview", {
    props: ["inview"],

    inview: 0.25, //if 25% of item is visible, or 25% of window moved after item become visible(when item is too large), add active

    selector: ".main, .obj-wrap, [data-inview], [data-right-navigation]",

    init: function () {
      var inviewRate = this.el.is(".main") ? 0 : this.inview;
      var isNavigationEl = this.el.is("[data-right-navigation]");
      var isOnlyNavigationEl = !this.el.is(
        this.selector.replace(", [data-right-navigation]", "")
      );

      apower.offset.add({
        el: this.el,
        rate: inviewRate,
        isNavigationEl: isNavigationEl,
        isOnlyNavigationEl: isOnlyNavigationEl,
      });
    },
  });
}
